import { render, staticRenderFns } from "./toolsI18nWizardsGroup.vue?vue&type=template&id=16351b43"
import script from "./toolsI18nWizardsGroup.vue?vue&type=script&lang=js"
export * from "./toolsI18nWizardsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports